<template>
    <div>
        <h1>Caseen Imaging Upload:</h1>
        <div id="dicom-drop">
        </div>
    </div>
</template>

<script>
    import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader"
    import dicomParser from "dicom-parser"
    // Specify external dependencies
    cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

    export default {
        methods: {
            initCornerstone: function(){
                // this function gets called once the user drops the file onto the div
                function handleFileSelect(evt) {
                    evt.stopPropagation();
                    evt.preventDefault();

                    // Get the FileList object that contains the list of files that were dropped
                    const files = evt.dataTransfer.files;

                    // this UI is only built for a single file so just dump the first one
                    var file = files[0];
                    const imageId = cornerstoneWADOImageLoader.wadouri.fileManager.add(file);
                    alert("Uploaded")
                    alert(imageId)
                }

                function handleDragOver(evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                    evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
                }

                // Setup the dnd listeners.
                const dropZone = document.getElementById('dicom-drop');
                dropZone.addEventListener('dragover', handleDragOver, false);
                dropZone.addEventListener('drop', handleFileSelect, false);

            }
        },
        mounted: function(){
            this.$nextTick(function(){
                this.initCornerstone()
            })
        }
    }
</script>

<style>
    #dicom-drop{
        background-color: #333;
        border: 1px solid #999;
        width: 400px;
        height: 400px;
    }
</style>
